<template>
  <div>
    <b-card no-body class="mb-1">
      <b-card-header class="p-1">
        <h4 class="font-weight-bold text-uppercase">
          Filters & Pencarian
        </h4>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col cols="12">
            <b-form-group label="Pencarian" label-for="searchTerm">
              <b-form-input id="searchTerm" v-model="formFilterDataTable.cari" placeholder="Pencarian data" type="text"
                class="d-inline-block" />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="d-flex justify-content-end">
            <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" size="md" @click="getDataBmd">
              <feather-icon icon="SearchIcon" class="mr-1" />Cari
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <b-card no-body class="mb-0">
      <div class="px-1 py-1 d-flex align-items-center justify-content-between">
        <h4 class="font-weight-bold text-uppercase">
          Daftar Jenis Ruangan
        </h4>
        <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" :to="{ name: 'masterJenisRuanganInput' }">
          <feather-icon icon="PlusIcon" class="mr-50" />
          <span class="align-middle">Tambah</span>
        </b-button>
      </div>
      <b-card-body>
        <b-row>
          <b-col cols="12">
            <vue-good-table :columns="columns" :rows="rows" :pagination-options="{
              enabled: true, perPage: row, jumpFirstOrLast: true,
            }" :total-rows="totalRecords" :is-loading.sync="isLoadingTable" mode="remote" @on-sort-change="onSortChange">
              <template slot="table-row" slot-scope="props">
                <!-- Column: aksi -->
                <span v-if="props.column.field === 'aksi'">
                  <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
                    <template v-slot:button-content>
                      <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-top mr-25" />
                    </template>
                    <b-dropdown-item v-if="$can('Detail', 'validasiKeberadaan')" :to="{
                      name: 'masterJenisRuanganUbah',
                      params: { id: props.row.id },
                    }">
                      <feather-icon icon="Edit2Icon" class="mr-50" />
                      <span>Ubah</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
              <template slot="pagination-bottom">
                <div class="d-flex justify-content-between flex-wrap">
                  <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> Menampilkan 1 hingga </span>
                    <b-form-select v-model="row" :options="['10','25','50']" class="mx-1"
                      @input="handlePageChange" />
                    <span class="text-nowrap">
                      dari {{ totalRecords }} entri
                    </span>
                  </div>
                  <div>
                    <b-pagination :value="1" :total-rows="totalRecords" :per-page="row" first-number last-number
                      align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0"
                      @change="handleChangePage">
                      <template #prev-text>
                        <feather-icon icon="ChevronLeftIcon" size="18" />
                      </template>
                      <template #next-text>
                        <feather-icon icon="ChevronRightIcon" size="18" />
                      </template>
                    </b-pagination>
                  </div>
                </div>
              </template>
            </vue-good-table>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>

import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'
import moment from 'moment'
import { VueGoodTable } from 'vue-good-table'
import { generateYears, startYear, generateMonths } from '@/libs/helper'
import masterJenisRuangan from '@/composables/master/jenisRuangan'

export default {
  setup(props, context) {
    // global variable
    const g = context.root
    const { $route } = g

    const cookiesJenisAkun = ref(g.$cookies.get('jenisAkun'))
    // variable untuk table
    const start = ref(0);
    const rows = ref([]);
    const row = ref(10);
    const totalRecords = ref(0);
    const sortColumn = ref("");
    const order = ref("");
    const isLoadingTable = ref(false);
    const formFilterDataTable = ref({
      limit: row.value,
      start: start.value,
      cari: null,
    });
    const getDataBmd = () => {
      isLoadingTable.value = true;
      let params = {
        limit: formFilterDataTable.value.limit,
        start: formFilterDataTable.value.start,
        cari: formFilterDataTable.value.cari,
      }
      masterJenisRuangan.getData(g, params).then(resp => {
        if (resp.success) {
          rows.value = resp.rows;
          totalRecords.value = resp.totalRows;
        } else {
          rows.value = [];
          totalRecords.value = 0;
        }
        isLoadingTable.value = false;
      }).catch((err) => {
        console.log(err)
        isLoadingTable.value = false;
      });
    };

    const handleSearch = (searching) => {
      formFilterDataTable.value.start = 0;
      getDataBmd();
    };

    const handlePageChange = (length) => {
      formFilterDataTable.value.limit = length;
      getDataBmd();
    };

    const handleChangePage = (page) => {
      formFilterDataTable.value.start = (page - 1) * row.value;
      getDataBmd();
    };

    const onSortChange = (params) => {
      sortColumn.value = params[0].field;
      order.value = params[0].type;
      getDataBmd();
    };

    getDataBmd();

    return {
      formFilterDataTable,
      handleSearch,
      handlePageChange,
      handleChangePage,
      onSortChange,
      getDataBmd,
      rows,
      start,
      row,
      totalRecords,
      sortColumn,
      order,
      isLoadingTable,
    }
  },
  components: {
    VueGoodTable,
  },
  directives: {
    Ripple,
  },
  props: {
    page: String,
  },
  data() {
    return {
      columns: [
        {
          label: 'Aksi',
          field: 'aksi',
          width: '1%',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },
        {
          label: 'Jenis Ruangan',
          field: 'jenis_ruangan',
          thClass: 'text-uppercase bg-light-primary pb-1',
          sortable: false,
        },

      ],
    }
  },
}
</script>
<style lang="scss" scope>
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
